import Link from "next/link";

export default function Footer() {
	const quickLinks = [
		{ href: "/about", label: "About" },
		{ href: "/registration", label: "Registration" },
		{ href: "/gallery", label: "Gallery" },
		{ href: "/team", label: "Team" },
		{ href: "/faq", label: "FAQs" },
	];

	const socialLinks = [
		{
			Icon: (
				<svg
					width="18"
					height="27"
					viewBox="0 0 18 33"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M15.9883 17.9688L16.875 12.1875H11.3281V8.43594C11.3281 6.85406 12.103 5.3125 14.5875 5.3125H17.1094V0.390625C17.1094 0.390625 14.8206 0 12.6323 0C8.06406 0 5.07812 2.76875 5.07812 7.78125V12.1875H0V17.9688H5.07812V31.9445C6.11191 32.1065 7.15673 32.1877 8.20312 32.1875C9.24952 32.1877 10.2943 32.1065 11.3281 31.9445V17.9688H15.9883Z"
						fill="white"
						stroke="white"
					/>
				</svg>
			),
			href: "https://www.facebook.com/share/1CkruSs2Lw/",
			label: "Facebook",
		},
		{
			Icon: (
				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M0.75 9.75C0.75 5.50768 0.75 3.38558 2.06779 2.06779C3.38558 0.75 5.50674 0.75 9.75 0.75C13.9923 0.75 16.1144 0.75 17.4322 2.06779C18.75 3.38558 18.75 5.50674 18.75 9.75C18.75 13.9923 18.75 16.1144 17.4322 17.4322C16.1144 18.75 13.9933 18.75 9.75 18.75C5.50768 18.75 3.38558 18.75 2.06779 17.4322C0.75 16.1144 0.75 13.9933 0.75 9.75Z"
						stroke="white"
						stroke-width="1.5"
						stroke-linejoin="round"
					/>
					<path
						d="M14.0136 9.75046C14.0136 10.8811 13.5645 11.9655 12.765 12.765C11.9655 13.5645 10.8811 14.0136 9.75046 14.0136C8.6198 14.0136 7.53545 13.5645 6.73596 12.765C5.93646 11.9655 5.4873 10.8811 5.4873 9.75046C5.4873 8.6198 5.93646 7.53545 6.73596 6.73596C7.53545 5.93646 8.6198 5.4873 9.75046 5.4873C10.8811 5.4873 11.9655 5.93646 12.765 6.73596C13.5645 7.53545 14.0136 8.6198 14.0136 9.75046Z"
						stroke="white"
						stroke-width="1.5"
					/>
					<path
						d="M14.9685 4.53906H14.959"
						stroke="white"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round"
					/>
				</svg>
			),
			href: "https://www.instagram.com/rff_academy1?igsh=bGNqZGxkNW1hZmh2",
			label: "Instagram",
		},
		{
			Icon: (
				<svg
					width="23"
					height="16"
					viewBox="0 0 23 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M22.9947 5.63862C23.0464 4.15808 22.7193 2.68862 22.044 1.36668C21.5857 0.824251 20.9498 0.4582 20.247 0.332307C17.34 0.0704419 14.4209 -0.0365972 11.5023 0.0116522C8.59436 -0.0369725 5.68586 0.0666091 2.78897 0.321963C2.21625 0.425107 1.68624 0.69107 1.26362 1.0874C0.323328 1.94592 0.218852 3.41473 0.114375 4.65597C-0.0381251 6.88766 -0.0381251 9.127 0.114375 11.3587C0.144991 12.0573 0.25005 12.7507 0.427804 13.4274C0.553777 13.9498 0.808645 14.4332 1.16959 14.8342C1.59509 15.2515 2.13744 15.5326 2.72628 15.641C4.97865 15.9169 7.24824 16.031 9.51725 15.9823C13.1739 16.034 16.3813 15.9823 20.1738 15.6927C20.7767 15.5897 21.334 15.3084 21.7723 14.8859C22.0645 14.5959 22.2829 14.2414 22.4096 13.8515C22.7829 12.7163 22.9664 11.5284 22.9529 10.3347C22.9947 9.75541 22.9947 6.25924 22.9947 5.63862ZM9.14114 10.9553V4.55253L15.3261 7.76942C13.5918 8.72104 11.3038 9.79679 9.14114 10.9553Z"
						fill="white"
					/>
				</svg>
			),
			href: "https://youtube.com/@reliancefuturefootballacademy?si=tZ7cdqQS8NXvH1ht",
			label: "YouTube",
		},
		{
			Icon: (
				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M11.9028 8.46875L19.3482 0H17.5837L11.1191 7.35313L5.95554 0H0L7.80819 11.1194L0 20H1.7645L8.59159 12.2348L14.0445 20H20L11.9023 8.46875H11.9028ZM9.48614 11.2172L8.69491 10.11L2.4002 1.29969H5.11034L10.19 8.41L10.9811 9.51719L17.5845 18.7594H14.8746L9.48614 11.2177V11.2172Z"
						fill="white"
					/>
				</svg>
			),
			href: "https://x.com/RFFAcademy?t=-1iy5omF0aVbc-pn3ZVi2g&s=09",
			label: "Twitter",
		},
		{
			Icon: (
				<svg
					width="20"
					height="23"
					viewBox="0 0 20 23"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M14.7539 0.00390625H11.2109V15.5156C11.2109 17.3203 9.72656 18.7695 7.92969 18.7695C6.13281 18.7695 4.64844 17.3203 4.64844 15.5156C4.64844 13.75 6.09375 12.3398 7.8125 12.2617V8.67969C4.17188 8.75781 1.25 11.7578 1.25 15.5156C1.25 19.3125 4.25 22.3906 8.00781 22.3906C11.7656 22.3906 14.7656 19.2734 14.7656 15.5156L14.7539 7.57422C16.1172 8.57422 17.8359 9.17969 19.6328 9.21875V5.67578C16.6992 5.55859 14.7539 3.16406 14.7539 0.00390625Z"
						fill="white"
					/>
				</svg>
			),
			href: "https://www.tiktok.com/@rffacademy?_t=ZS-90r7dy88rHW&_r=1",
			label: "TikTok",
		},
	];

	return (
		<footer className="bg-black text-white">
			<div className="container mx-auto px-4 py-12">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
					{/* Ready for Training Section */}
					<div>
						<h3 className="text-xl font-bold mb-4 text-white">
							READY FOR YOUR <p className="text-primary inline">FIRST</p>{" "}
							TRAINING?
						</h3>
						<p className="text-gray-400 text-sm leading-relaxed">
							Where passion meets purpose. <br /> Train hard. Play smart. Dream
							big.
						</p>
					</div>

					{/* Quick Links */}
					<div>
						<h3 className="text-xl font-bold mb-4">QUICK LINKS</h3>
						<ul className="space-y-3">
							{quickLinks.map((link) => (
								<li key={link.href}>
									<Link
										title={link.label}
										href={link.href}
										className="text-gray-300 hover:text-primary transition-colors"
									>
										{link.label}
									</Link>
								</li>
							))}
						</ul>
					</div>

					{/* Contact */}
					<div>
						<h3 className="text-xl font-bold mb-4">CONTACT</h3>
						<div className="space-y-4">
							<a
								href="tel:+2349150154131"
								className="block text-gray-300 hover:text-primary transition-colors"
							>
								+234 915 015 4131
							</a>
							<a
								href="mailto:info@rffacademy.org"
								className="block text-gray-300 hover:text-primary transition-colors break-all"
							>
								info@rffacademy.org
							</a>

							<div>
								<p className="text-gray-300 text-sm leading-relaxed">
									Secretary RFFA: B30, Grand Mall, Opposite Arisekola Alubarika
									Shopping Complex, Bodija, Ibadan, Oyo State.
								</p>
							</div>

							<div className="pt-2">
								<h4 className="text-sm font-bold mb-3">
									FOLLOW US ON SOCIAL MEDIA
								</h4>
								<div className="flex space-x-3">
									{socialLinks.map(({ Icon, href, label }) => (
										<a
											key={label}
											href={href}
											aria-label={label}
											className="w-10 h-10 text-white fill-white rounded-full bg-primary hover:bg-blue-700 flex items-center justify-center transition-colors"
										>
											{Icon}
										</a>
									))}
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Bottom Bar */}
				<div className="mt-12 pt-8 border-t border-gray-300 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
					<p className="text-gray-400 text-sm">
						Copyright 2025 RFFA - All Rights Reserved
					</p>
					<Link
						href="/privacy"
						className="text-gray-400 hover:text-primary text-sm transition-colors"
					>
						Privacy Policy
					</Link>
				</div>
			</div>
		</footer>
	);
}
